(function($){

    // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('#fixedContent').removeClass('disable');
					  $('body').removeClass('c-scroll-disable');
            $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#mainMenu').animate({right: '-100vh'}).fadeOut(1000);
        } else {
            $('#fixedContent').addClass('disable');
					  $('body').addClass('c-scroll-disable');
            $(this).addClass('open');
            $('#mainMenu').fadeIn(100).animate({right: '0'});
            $('#siteLogo').addClass('reposition');
            $('#siteLogo').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('#fixedContent').removeClass('disable');
				  $('body').removeClass('c-scroll-disable');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').animate({right: '-100vh'}).fadeOut(1000);

	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });


    // Initiate aos animations
	AOS.init();


    // Remove empty paragraphs
    $('p:empty:not([role])').remove();

        //header on scroll
        window.onload = (function(){
            $(window).scroll(function () { 
                if( $(window).scrollTop() > 600 ) {
                  $('#siteHeader').addClass('header-fixed')
                }
                if( $(window).scrollTop() < 600 ) {
                  $('#siteHeader').removeClass('header-fixed')
                }
             })
            })

})(jQuery);
